export default __webpack_public_path__ + "static/media/M_R-White.76c4d385.png";